import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import * as endPoints from "../../../../../config/config";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";
import { AxiosError } from "axios";

interface UpdateReqTSXProps {
    id : number;
}

interface JobProps {
    id? : 0;
    position_title: string;
    client_id: number;
    domain_id: number;
    segment_id: number;
    sub_segment_id: number;
    status: number;
    career_level: string;
    updated_fte: number;
    budget: string;
    shift_schedule: string;
    location: string;
    job_description: string;
}

interface clientProps {
    id: number;
    client_name: string;
}

interface domainProps {
    id: number;
    domain_name: string;
}

interface segmentProps {
    id: number;
    segment_name: string;
}

interface subSegmentProps {
    id: number;
    sub_segment_name: string;
}

interface statusProps {
    id : number;
    status : string;
}

const UpdateRequirements : React.FC<UpdateReqTSXProps> = ({id}) => {
    const [loading, setLoading] = useState<boolean>(true);
     const [jdlData, setJdlData] = useState<JobProps>({
        position_title : '',
        client_id : 0,
        domain_id : 0,
        segment_id : 0,
        sub_segment_id : 0,
        career_level : '',
        updated_fte : 0,
        budget : '',
        shift_schedule: '',
        location: '', 
        job_description : '',
        status : 0
    });
    const [Clients, setClients] = useState<clientProps[] | null>(null);
    const [Domains, setDomains] = useState<domainProps[] | null>(null);
    const [Segments, setSegments] = useState<segmentProps[] | null>(null);
    const [subSegments, setSubSegments] = useState<subSegmentProps[] | null>(null);
    const [status, setStatus] = useState<statusProps[] | null>(null);
    const [msg, setMsg] = useState({msg : '', success : true});

    useEffect(()=>{
        const loadRequirements = async() => {
            try{
                const role = await api.get(endPoints.GET_JDL_TBL_END_POINT+id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                });
                const role_details = role.data as JobProps;
                setJdlData(role_details);
                const clients = await api.get(endPoints.GET_CLIENTS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                });
                const client_data = clients.data as clientProps[]
                setClients(client_data);
                const domains = await api.get(endPoints.GET_ALL_DOMAINS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const domains_data = domains.data as domainProps[];
                setDomains(domains_data);
                const segments = await api.get(endPoints.GET_SEGMENT_BY_DOMAIN_END_POINT+role_details.domain_id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const segments_data = segments.data as segmentProps[]
                setSegments(segments_data);
                const sub_segments = await api.get(endPoints.GET_SUB_SEGMENTS_END_POINT+role_details.segment_id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const sub_segments_data = sub_segments.data as subSegmentProps[];
                setSubSegments(sub_segments_data);
                const status = await api.get(endPoints.GET_JDL_STATUS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const status_data = status.data as statusProps[];
                setStatus(status_data);
                setLoading(false);
            }catch(e){}
        }
        loadRequirements();
    },[id]);

    useEffect(()=>{
        const updateDropDowns = async() => {
            try{
                const domains = await api.get(endPoints.GET_ALL_DOMAINS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const domains_data = domains.data as domainProps[];
                setDomains(domains_data);
                const segments = await api.get(endPoints.GET_SEGMENT_BY_DOMAIN_END_POINT+jdlData.domain_id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const segments_data = segments.data as segmentProps[]
                setSegments(segments_data);
                const sub_segments = await api.get(endPoints.GET_SUB_SEGMENTS_END_POINT+jdlData.segment_id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const sub_segments_data = sub_segments.data as subSegmentProps[];
                setSubSegments(sub_segments_data);
            }catch(e){}
        }
        updateDropDowns();
    },[jdlData])

    const isValidData = (data: Record<string, any>) => 
        Object.values(data).every(value => value !== "" && value !== 0);

    const handleUpdateRole = async() => {
        setLoading(true);
        try{
            if(isValidData(jdlData)){
                await api.put(endPoints.UPDATE_JDL_END_POINT+id, jdlData, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setMsg({msg : 'Role updated!', success : true});
                setLoading(false);
            }else{
                setMsg({msg : 'Please complete all fields!', success : false});
                setLoading(false);
            }
            
        }catch(e){
            const error = e as AxiosError;
            if(error.response?.status === 304){
                setMsg({msg : 'No changes found!', success : false});
            }else{
                setMsg({msg : 'An error occured!', success : false});
            }
            
            setLoading(false);
        }
    }
    return (
        <div className="min-w-96 relative">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div>
                Update Job
            </div>
            <div className={msg.success ? 'text-green-500' : 'text-red-500'}>
                {msg.msg}
            </div>
            <div>
                <form>
                    <div className='flex gap-4'>
                        <div className='flex flex-col min-w-80 max-w-52 min-h-80 pt-4'>
                            <div className='input-container my-0'>
                                <label htmlFor="">Position Title:</label>
                                <input type="text" name="position_title" onChange={(e) => setJdlData(prevState => ({ ...prevState, position_title: e.target.value }))} value={jdlData.position_title} className='text-box w-full' />
                            </div>
                            <div className='input-container relative my-0'>
                                <label htmlFor="">Client Name:</label>
                                <select onChange={(e) => setJdlData(prevState => ({ ...prevState, client_id: parseInt(e.target.value)}))} className='text-box w-full'>
                                    <option value="" className="text-gray-400">Choose client</option>
                                    { Clients?.map(client => (
                                        <option selected={client.id === jdlData.client_id} value={client.id}>{client.client_name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='input-container relative my-0'>
                                <label htmlFor="">Domain:</label>
                                <select onChange={(e) => setJdlData(prevState => ({ ...prevState, domain_id: parseInt(e.target.value)}))} className='text-box w-full'>
                                    <option value="" className="text-gray-400">Choose domain</option>
                                    { Domains?.map(domain => (
                                        <option selected={domain.id === jdlData.domain_id} value={domain.id}>{domain.domain_name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='input-container relative my-0'>
                                <label htmlFor="">Segment:</label>
                                <select onChange={(e) => setJdlData(prevState => ({ ...prevState, segment_id: parseInt(e.target.value)}))} className='text-box w-full'>
                                    <option value="" className="text-gray-400">Choose segment</option>
                                    { Segments?.map(segment => (
                                        <option selected={segment.id === jdlData.segment_id} value={segment.id}>{segment.segment_name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='input-container my-0'>
                                <label htmlFor="">Sub-Segment:</label>
                                {subSegments ? (
                                    <select onChange={(e) => setJdlData(prevState => ({ ...prevState, sub_segment_id: parseInt(e.target.value)}))} className='text-box w-full'>
                                        <option value="" className="text-gray-400">Choose Sub Segment</option>
                                        { subSegments.map(seg => (
                                        <option selected={seg.id === jdlData.sub_segment_id} value={seg.id}>{seg.sub_segment_name}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <select className='text-box w-full'>
                                        <option value="" className="text-gray-400">No sub segment available.</option>
                                    </select>
                                )}
                                    
                            </div>
                            <div className='input-container my-0'>
                                <label htmlFor="">Shift Schedule: </label>
                                <input type="text" name="shift_sched" onChange={(e) => setJdlData(prevState => ({ ...prevState, shift_schedule: e.target.value }))} value={jdlData.shift_schedule} className='text-box w-full' />
                            </div>
                            <div className='input-container my-0'>
                                <label htmlFor="">Location: </label>
                                <input type="text" name="location" onChange={(e) => setJdlData(prevState => ({ ...prevState, location: e.target.value }))} value={jdlData.location} className='text-box w-full' />
                            </div>
                            <div className='flex gap-4 w-full'>
                                <div className='input-container my-0 w-full'>
                                    <label htmlFor="">Career Level:</label>
                                    <input type="text" maxLength={5} onChange={(e) => setJdlData(prevState => ({ ...prevState, career_level: e.target.value }))} value={jdlData.career_level} name="career_level" className='text-box w-full' />
                                </div>
                                <div className='input-container my-0 w-full'>
                                    <label htmlFor="">Updated FTE:</label>
                                    <input type="number" name="fte" onChange={(e) => setJdlData(prevState => ({ ...prevState, updated_fte: parseInt(e.target.value)}))} value={jdlData.updated_fte} className='text-box w-full' />
                                </div>
                            </div>
                            <div className='flex gap-4 w-full'>
                                <div className='input-container my-0'>
                                    <label htmlFor="">Budget:</label>
                                    <input type="text" name="budget" onChange={(e) => setJdlData(prevState => ({ ...prevState, budget: e.target.value }))} value={jdlData.budget} className='text-box w-full' />
                                </div>
                                <div className='input-container my-0'>
                                    <label htmlFor="">Status:</label>
                                    <select onChange={(e) => setJdlData(prevState => ({ ...prevState, status: parseInt(e.target.value)}))} name="status"  className='text-box w-full'>
                                        <option value="" className="text-gray-400">Select Status</option>
                                        {status?.map((value)=>(
                                            <option selected={value.id === jdlData.status} value={value.id}>{value.status}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="min-w-80 min-h-80 mb-4">
                            <div className="input-container h-full flex flex-col relative">
                                <label htmlFor="#jd">Job Description:</label>
                                <textarea name="job_description" id="jd" onChange={(e) => setJdlData(prevState => ({ ...prevState, job_description: e.target.value }))} value={jdlData.job_description} className="text-box p-2 w-full h-full" ></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-4 justify-end my-2 pe-4">
                        <div>
                            <button type="button" onClick={handleUpdateRole} className='button button-vcc-green text-md px-4'>
                                Update
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default UpdateRequirements;